import app from 'flarum/forum/app';
import { extend, override } from 'flarum/common/extend';
import LogInButtons from 'flarum/forum/components/LogInButtons';
import LogInButton from 'flarum/forum/components/LogInButton';
import extractText from 'flarum/common/utils/extractText';
import Tooltip from 'flarum/common/components/Tooltip';
import { oauthOnly } from './extendOAuthOnly';
/**
 * Build the OAuth authorization URL for a given provider path.
 * Appends returnTo so the server can redirect back after auth.
 */
function oauthUrl(path) {
  const base = app.forum.attribute('baseUrl');
  const returnTo = encodeURIComponent(window.location.pathname + window.location.search);
  return `${base}${path}?returnTo=${returnTo}`;
}
export default function () {
  // Replace the popup onclick with a full-page navigation.
  override(LogInButton, 'initAttrs', function (original, attrs) {
    original(attrs);

    // Override whatever onclick the parent set — we navigate instead of opening a popup.
    attrs.onclick = function (e) {
      e.preventDefault();
      window.location.href = oauthUrl(attrs.path);
    };
  });
  extend(LogInButtons.prototype, 'items', function (items) {
    const onlyIcons = app.forum.attribute('fof-oauth.only_icons');
    const enabledOAuthProviders = app.forum.attribute('fof-oauth')?.filter(provider => provider !== null) ?? [];
    enabledOAuthProviders.forEach(_ref => {
      let {
        name,
        icon,
        priority
      } = _ref;
      // Signing in with this provider again would only repeat the unverified email notice.
      if (name === app.fof_oauth_unverifiedEmailProvider) return;
      let className = `Button FoFLogInButton LogInButton--${name}`;
      if (onlyIcons) {
        className += ' Button--icon';
      }
      items.add(name, m("div", {
        className: `LogInButtonContainer LogInButtonContainer--${name}`
      }, m(LogInButton, {
        className: className,
        icon: icon,
        path: `/auth/${name}`
      }, app.translator.trans(`fof-oauth.forum.log_in.with_${name}_button`, {
        provider: app.translator.trans(`fof-oauth.forum.providers.${name}`)
      }))), priority);
    });
  });
  override(LogInButton.prototype, 'view', function (original, vnode) {
    const onlyIcons = app.forum.attribute('fof-oauth.only_icons');
    if (!onlyIcons) return original(vnode);
    const child = original(vnode);

    // @ts-ignore
    return m(Tooltip, {
      text: extractText(child.children[1])
    }, child);
  });
  extend(LogInButtons.prototype, 'view', function (vdom) {
    const onlyIcons = app.forum.attribute('fof-oauth.only_icons');
    if (!onlyIcons) return;

    // @ts-ignore
    vdom.attrs.className += ' FoFLogInButtons--icons';
  });
  extend('flarum/forum/components/SignUpModal', 'fields', function (items) {
    // If a suggested username was not provided by the OAuth service, display help text.
    if (!!this.attrs.token && !this.attrs.username) {
      items.add('username-help', m("div", null, m("p", null, app.translator.trans('fof-oauth.forum.signup.username_help'))), 35);
    }
  });

  // LogInModal is lazy loaded in 2.x, so it is extended by module path.
  extend('flarum/forum/components/LogInModal', 'oninit', function () {
    const provider = this.attrs.fofOAuthUnverifiedEmailProvider;
    if (provider) {
      app.fof_oauth_unverifiedEmailProvider = provider;
      const providerName = app.translator.trans(`fof-oauth.forum.providers.${provider}`);

      // In OAuth-only mode there is no password login to link the provider from.
      this.alertAttrs = {
        type: 'warning',
        content: oauthOnly() ? app.translator.trans('fof-oauth.forum.log_in.unverified_email_in_use_oauth_only', {
          provider: providerName
        }) : app.translator.trans('fof-oauth.forum.log_in.unverified_email_in_use', {
          provider: providerName
        })
      };
    }
  });
  extend('flarum/forum/components/LogInModal', 'onremove', function () {
    if (this.attrs.fofOAuthUnverifiedEmailProvider) {
      app.fof_oauth_unverifiedEmailProvider = undefined;
    }
  });
}